export default __webpack_public_path__ + "static/media/Logo.1bb91e27.png";